import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-page-loader',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe
],
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent {
  @Input() fullScreen: boolean = true;
  @Input() message: string = ''; // Opzionale: "Caricamento in corso..."
}